module.exports = __webpack_public_path__ + "img/na.5817eb6b.svg";